function getFormGuardState(state) {
  return {
    dirtyForm: state.formGuard.dirtyForm
  };
}

export { getFormGuardState };
